import { Provider } from "react-redux";
import { ToastContainer } from "react-toastify";
import store from "./store/store";
import AppRoutes from "./routes/AppRoutes";
import { HashRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

function App() {
  // useEffect(() => {
  //   const token = getUserToken() || {};
  //   if (token) {
  //     WebSocketOnline.connect(token);
  //     WebSocketOnline.callbacks.onmessage = (data) => {
  //       console.log("Received WebSocket data:", data);
  //     };
  //   }
  //   return () => {
  //     WebSocketOnline.disconnect();
  //   };
  // }, []);

  // const { user } = getUserDetails() || {};
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        retry: 1,
        staleTime: 1000 * 60 * 5, // 5 minutes
      },
    },
  });
  return (
    <HashRouter>
      <Provider store={store}>
        <ToastContainer />
        {/* <NotificationListener /> */}
        <QueryClientProvider client={queryClient}>
          {/* {user && <ChatNotifications currentUser={user} />} */}
          <AppRoutes />
          <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
      </Provider>
    </HashRouter>
  );
}

export default App;
